const FILTERS = {
    "ansible-object": {
        object_storage_ansible_module: {
            title: 'VSP One Object Modules',
            iconClass: 'network-wired'
        },
        ansible: {
            title: 'Ansible',
            icon: 'server.png'
        },
        python: {
            title: 'Python',
            icon: 'os.png'
        },
        vsp_one_object_version: {
            title: 'VSP One Object Version',
            icon: 'switch.png'
        }

    }
}
export default FILTERS;